export const firebaseConfig = {
  apiKey: "AIzaSyDTPMTYZARsc60xbN-WqG7yWNUQ80IKC0s",
  authDomain: "rbs-staff-app.firebaseapp.com",
  databaseURL: "https://rbs-staff-app.firebaseio.com",
  projectId: "rbs-staff-app",
  storageBucket: "rbs-staff-app.appspot.com",
  messagingSenderId: "30258689984",
  appId: "1:30258689984:web:476316bdc01a0f87d5ba25"
};
